// extracted by mini-css-extract-plugin
module.exports = {"arrowBody":"CancelIcon_arrowBody__193o1","icon":"CancelIcon_icon__39Ukb"};